import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { SessionOldModel } from '@core/Models/sessionOld.model';
import { AlertController, LoadingController, ModalController, Platform, ToastController } from '@ionic/angular';
import { StorageMap } from '@ngx-pwa/local-storage';
import { BehaviorSubject, lastValueFrom } from 'rxjs';
import { LeavePageComponent } from 'src/app/POPUP/leave-page/leave-page.component';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';


@Injectable({
  providedIn: 'root'
})
export class HelperService {

public toggleMenu = signal<boolean>(false);

private screenWidth = new BehaviorSubject<number>(window.innerWidth);

screenWidth$ = this.screenWidth.asObservable();

constructor(
  private storage: StorageMap,
  private loading:LoadingController,
  private alertCtrl: AlertController,
  private http:HttpClient,
  private platform: Platform,
  private modalController: ModalController,
  private router: Router,
  private toastController: ToastController
) { }

setStorage(key:string,value:any){
  lastValueFrom(this.storage.set(key,value))
}

getStorage(key:string){
  return lastValueFrom(this.storage.get(key));
}

removeStorage(key:string){
  lastValueFrom(this.storage.delete(key));
}

async showLoading(message?: any) {
  await this.loading
    .create({ keyboardClose: true, message: message })
    .then((res) => {
      res.present();
    });

    return;
}

dismissLoading() {
  this.loading.getTop().then((hasLoading) => {
    if (hasLoading) {
      this.loading.dismiss();
    }
  })
}

showAlert(message: string, button: any = ['OK'], allowBackdrop: any = true) {
  this.alertCtrl
    .create({
      mode: 'ios',
      cssClass: 'custom-alert',
      message: message,
      backdropDismiss: allowBackdrop,
      buttons: button,
    })
    .then((alert: any) => {
      alert.present();
    });
}

showAlertRefresh(message: string, button: any = ['Refresh Halaman'], allowBackdrop: any = true) {
  this.alertCtrl
    .create({
      mode: 'ios',
      cssClass: 'custom-alert',
      message: message,
      backdropDismiss: allowBackdrop,
      buttons: [
        {
          text: 'Refresh Halaman',
          handler: () => {
            window.location.reload()
          }
        }
      ]
    })
    .then((alert: any) => {
      alert.present()
    });
}

errorAlertHandler(err: any) {


  if (err?.error?.message) {

    try {

      //console.log('9999')
      //console.log(err.error.errors[Object.keys(err.error.errors)[0]][0])

      if(err.error.errors[Object.keys(err.error.errors)[0]][0] === "The is accept t n c field must be true or false."){
        this.showAlert("Silakan checklist T&C terlebih dahulu");
      }else if(err.error.errors[Object.keys(err.error.errors)[0]][0].includes('Silakan refresh ulang halaman')){
        this.showAlertRefresh(err.error.errors[Object.keys(err.error.errors)[0]][0]);
      }else if(err.error.errors[Object.keys(err.error.errors)[0]][0].includes('BROWSER_ERROR')){
        this.showAlertRefresh(err.error.errors[Object.keys(err.error.errors)[0]][0]);
      }else{
        this.showAlert(err.error.errors[Object.keys(err.error.errors)[0]][0]);
      }


      // this.popupUp(
      //   'error',
      //   'Error',
      //   err.error.errors[Object.keys(err.error.errors)[0]][0],
      // );
    } catch (error) {
      if (err.status == 401) {
        this.showAlert('Internal Server Error [14]');
        // this.popupUp('error', 'Error', 'Internal Server Error [14]');

        // location.reload();
      } else if (err.error.message) {
        this.showAlert(err.error.message);
        // this.popupUp('error', 'Error', err.error.message);
      } else {
        this.showAlert('Internal Server Error');
        // this.popupUp('error', 'Error', 'Internal Server Error');
      }
    }
  } else {

    this.alertCtrl.getTop().then((hasAlert) => {
      if(!hasAlert){
        this.showAlert(err);
      }
    })
  }
}

getFirstHtppErrMessage(data:any){

  var message = ''

  for(const key in data){

    var err = data[key]

    if(message == ''){
      message = err[0];
    }

  }

  return message

}

//--------------------------- POP UP-------------------------//
showPopup(icon: any, title: any, msg: any, timer: boolean = false) {
  Swal.fire({
    title: title,
    html: msg,
    timer: timer ? 3000 : 0,
    icon: icon,
    allowOutsideClick: false,
    heightAuto: false,
    allowEscapeKey: false,
  });
}

dismissPopup() {
  Swal.close();
}

//-------------- MARK:FUNCTION ----------------//

findInvalidControls(form: FormGroup) {
  const invalid = [];
  const controls = form.controls;
  for (const name in controls) {
    if (controls[name].invalid) {
      invalid.push(name);
    }
  }
  return invalid;
}

isMobile(){
  if(this.platform.is('mobile')){
    return true
  }else{
    return false
  }
}

textToSlug(text:string){
  return text
  .toLowerCase() // Mengubah string menjadi huruf kecil
  .trim() // Menghapus spasi di awal dan akhir
  .replace(/[^a-z0-9 -]/g, '') // Menghapus karakter yang tidak diinginkan
  .replace(/\s+/g, '-') // Mengganti spasi dengan tanda hubung
  .replace(/--+/g, '-'); // Mengganti tanda hubung ganda dengan tanda hubung tunggal
}

slugToText(slug:any){
  return slug
      .replace(/-/g, ' ')
      .replace(/\b\w/g, (char: string) => char.toUpperCase());
}

openNewTabNoModal(url:any, norumahsaya?:boolean, analytic?:any) {
  if(url && url != ''){
    if(url.includes(environment.webUrl)){
      this.router.navigateByUrl(url.replace(environment.webUrl, ''))
    }else{
      this.modalLeavePage(url,norumahsaya,analytic)
    }
  }
}

openNewTabNormal(url:any) {
  if(url && url != ''){
    window.open(url, "_blank");
  }
}

async modalLeavePage(url:string,norumahsaya?:boolean,analytic?:any) {
  const modal = await this.modalController.create({
    component: LeavePageComponent,
    cssClass: 'auto-height',
    componentProps: {
      redirect: url,
      isRumahSaya:norumahsaya ? false : true,
      analytic:analytic ? analytic : null
    }

  });
  return await modal.present();
}

getDataEncryption(fullname:any, email:any, phone:any, model:any, brand:any, locationId:any, promo:any) {
  let body = new FormData();

  body.append("fullname", fullname);
  body.append("email", email);
  body.append("phone", phone);
  body.append("model", model);
  body.append("brand", brand);
  body.append("location", locationId);
  body.append("promo", promo);
  return this.http.post<any>(
    `${environment.apiUrl}/getencryption`,
    body
  );
}

shuffleArray(array:any[]) {
  let currentIndex = array.length,  randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex > 0) {

    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
}

spliceArrayByIndex(array:any[], index:number){

  var result:any[] = []
  array = array.splice(index, 1);

  return array;

}

async presentToast(message:any) {
  const toast = await this.toastController.create({
    message: message,
    duration: 2000,
  });
  toast.present();
}

toSession(sessionID:string, session:SessionOldModel){

  if(session.getStreamType() == 'external_link'){
    this.getEventSessionStream(sessionID).subscribe()
    this.openNewTabNoModal(session.getStreamResource().getUrl())
  }else{
    this.router.navigateByUrl(`/session/${sessionID}`)
    // this.showAlert('show opening ceremony')
  }

}

//-------------- MARK:HTTPREQUEST ----------------//
getExhibitorOperational(exhibitorID:any){

  return this.http.get<any>(
    `${environment.apiUrl}/events/${environment.eventId}/exhibitors/${exhibitorID}/operationalTime`,
  );

}

sendAnalytic(type:any, action:any) {
  let body = new FormData();

  body.append("api_key", 'b884f40d1f1b19630a8f962ad24526a77206aaf2940cc0822e0888cab256d98e');
  body.append("type", type);
  body.append("action", action);
  body.append("additional_data", localStorage['dataGlobal']);
  return this.http.post<any>(`${environment.urlAnalytic}`, body);
}

getEventSessionStream(sessionId:any){

  return this.http.get<any>(
    `${environment.apiUrl}/events/${environment.eventId}/sessions/${sessionId}/stream`,
  );

}

}
